/**
 * Header da janela + barra de busca na conversa (oculto em popup).
 */
import React from 'react';
import type { ChatConversation } from '../../hooks/types';
import { ChatHeader } from './ChatHeader';
import { MessageSearchBar } from './MessageSearchBar';

interface ChatWindowChromeProps {
    conversation: ChatConversation;
    onTransfer?: (userId: string) => void;
    onCloseConversation?: () => void;
    onReopenConversation?: () => void;
    isSearchOpen: boolean;
    selectedTagIds?: string[];
    onBack?: () => void;
    onToggleSearch: () => void;
    isContactPanelOpen?: boolean;
    onToggleContactPanel?: () => void;
    onNavigateToMessage: (messageId: string) => void;
    onCloseSearch: () => void;
    onHighlightChange: (messageId: string | null) => void;
}

export const ChatWindowChrome: React.FC<ChatWindowChromeProps> = ({
    conversation,
    onTransfer,
    onCloseConversation,
    onReopenConversation,
    isSearchOpen,
    selectedTagIds,
    onBack,
    onToggleSearch,
    isContactPanelOpen,
    onToggleContactPanel,
    onNavigateToMessage,
    onCloseSearch,
    onHighlightChange,
}) => (
    <header className="relative z-10 shrink-0 bg-card shadow-sm">
        <ChatHeader
            conversation={conversation}
            onTransfer={onTransfer}
            onCloseConversation={onCloseConversation}
            onReopenConversation={onReopenConversation}
            isSearchOpen={isSearchOpen}
            selectedTagIds={selectedTagIds}
            onBack={onBack}
            onToggleSearch={onToggleSearch}
            isContactPanelOpen={isContactPanelOpen}
            onToggleContactPanel={onToggleContactPanel}
        />
        {isSearchOpen && (
            <MessageSearchBar
                messages={conversation.messages}
                onNavigateToMessage={onNavigateToMessage}
                onClose={onCloseSearch}
                onHighlightChange={onHighlightChange}
            />
        )}
    </header>
);
